import { Theme } from '@mui/material';

export const getRecoTableColumnsStyles = (theme: Theme) => ({
  textCell: {
    paddingTop: 5,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    color: 'inherit',
  },

  chipsContainerCell: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 5,
    color: 'inherit',
  },

  chipsContainerCellNoScroll: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    paddingTop: 8,
    color: 'inherit',
  },
});
